import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptions, Response} from '@angular/http';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Observable';
import 'rxjs/add/observable/throw';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/catch';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {Router} from '@angular/router';
import {Toast, ToasterService} from 'angular5-toaster/dist';
import {ErrorObservable} from 'rxjs/observable/ErrorObservable';
@Injectable()
export class HttpRequestService {

  constructor(private http: HttpClient, private toasterService: ToasterService, private router: Router) { }

  private handleError(error: HttpErrorResponse | any) {
    let errMsg: string;
    if (error.error instanceof ErrorEvent) {
      errMsg = error.error.message;
    } else {
      errMsg = error.error.message ? error.error.message : error.toString();
    }
    // console.log(errMsg);

    const toast: Toast = {
      type: 'error',
      title: 'Error',
      body: errMsg,
      showCloseButton: true,
      timeout: 5000
    };

    if (error.status === 403) {
        this.router.navigate(['/surveys']);
    } else {
        this.toasterService.pop(toast);
    }
    return new ErrorObservable({status: error.status, message: errMsg});
  }

  get(url: string, showSuccessToast?: boolean, toastMessage?: string) {
    return this.http.get(url)
      .map((response: any) => {

          if (showSuccessToast) {
            const toast: Toast = {
              type: 'success',
              title: 'Success',
              body: toastMessage ? toastMessage : 'Operation successful.',
              showCloseButton: true,
              timeout: 2000
            };

            this.toasterService.pop(toast);
          }

          return response;
      })
      .catch((response) => this.handleError(response));
  }

  delete(url: string, showSuccessToast?: boolean, toastMessage?: string) {
    return this.http.delete(url)
      .map((response: any) => {

          if (showSuccessToast) {
            const toast: Toast = {
              type: 'success',
              title: 'Success!',
              body: toastMessage ? toastMessage : 'Operation successful.',
              showCloseButton: true,
              timeout: 2000
            };

            this.toasterService.pop(toast);
          }

          return response;
      })
      .catch((response) => this.handleError(response));
  }

  post(url: string, request: any, showSuccessToast?: boolean, toastMessage?: string) {
    return this.http.post(url, request)
      .map((response: any) => {

          if (showSuccessToast) {
            const toast: Toast = {
              type: 'success',
              title: 'Success!',
              body: toastMessage ? toastMessage : 'Operation successful.',
              showCloseButton: true,
              timeout: 2000
            };

            this.toasterService.pop(toast);
          }

          return response;
      })
      .catch((response) => this.handleError(response));
  }

  put(url: string, request: any, showSuccessToast?: boolean, toastMessage?: string) {
    return this.http.put(url, request)
      .map((response: any) => {

        if (showSuccessToast) {
          const toast: Toast = {
            type: 'success',
            title: 'Success!',
            body: toastMessage ? toastMessage : 'Operation successful.',
            showCloseButton: true,
            timeout: 2000
          };

          this.toasterService.pop(toast);
        }

        return response;
      })
      .catch((response) => this.handleError(response));
  }

  postMultipart(url: string, data: any, files: File[], showSuccessToast?: boolean, toastMessage?: string) {
    const formData: FormData = new FormData();
    formData.append('data', JSON.stringify(data));

    for (const file of files) {
      formData.append(file.name, file);
    }

    return this.http.post(url, formData)
      .map((response: any) => {

          if (showSuccessToast) {
            const toast: Toast = {
              type: 'success',
              title: 'Success',
              body: toastMessage ? toastMessage : 'Operation successful.',
              showCloseButton: true,
              timeout: 2000
            };

            this.toasterService.pop(toast);
          }

          return response;

      })
      .catch((response) => this.handleError(response));
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/http-request.service.ts